import { useMediaQuery } from "@react-hookz/web";

const computedStyles = getComputedStyle(document.documentElement);
const getBreakpoint = (breakpoint: string) =>
  Number.parseInt(computedStyles.getPropertyValue(breakpoint).split("px")[0], 10);

export const breakpoints = {
  xs: getBreakpoint("--breakpoint-xs"),
  sm: getBreakpoint("--breakpoint-sm"),
  md: getBreakpoint("--breakpoint-md"),
  lg: getBreakpoint("--breakpoint-lg"),
  xl: getBreakpoint("--breakpoint-xl"),
};

type Breakpoint = keyof typeof breakpoints;

export const useBreakpoint = (breakpoint: Breakpoint) => !!useMediaQuery(`(min-width: ${breakpoints[breakpoint]}px)`);
